"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author ZSr
 * wrapper class for regular volume
 *
 */
//TODO since regularVolume is being rounded to given number of decimal digits (see BaselineServiceImpl), it must be BigDecimal!


var PromoRegularVolumeOutput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromoRegularVolumeOutput, _DomainObject_1$Domai);

  /**
   * @param productId the internal id of product
   * @param regularVolume
   */
  function PromoRegularVolumeOutput(productId, regularVolume) {
    var _this;

    _classCallCheck(this, PromoRegularVolumeOutput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoRegularVolumeOutput).call(this));
    _this.productId = productId;
    _this.regularVolume = regularVolume;
    return _this;
  }

  return PromoRegularVolumeOutput;
}(DomainObject_1.DomainObject);

exports.PromoRegularVolumeOutput = PromoRegularVolumeOutput;

PromoRegularVolumeOutput.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromoRegularVolumeOutput.name);
  return {
    productId: builder.id('productId'),
    regularVolume: builder.num('regularVolume')
  };
}();